import { render, staticRenderFns } from "./ConfirmarDados.vue?vue&type=template&id=4a4b85ac&"
import script from "./ConfirmarDados.vue?vue&type=script&lang=ts&"
export * from "./ConfirmarDados.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports